import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import Loader from 'src/components/common/Loader';
import { Grid, Typography } from '@mui/material';
import AppModal from 'src/components/modal';
import staticData from '../../../resources/static.json';
import forms from '../../../resources/forms.json';
import { useEffect, useRef, useState } from 'react';
import { useAppSelector } from 'src/store';
import { useShipDrugSuppplyMutation } from 'src/services/DrugSupply';
import { setMessage } from 'src/store/Message';
import { useUtil } from 'src/components/hooks/useUtil';
import { useDispatch } from 'react-redux';

const ShipDialog: React.FunctionComponent<any> = props => {
  const { openShipPopup, setOpenShipPopup, sites, selectedRowData, setSelectedRowData, getRowsData } = props;
  const shipData = staticData.Ship.shipData;
  const formGroup = forms.shipActivity;
  const { formFields, defaultValues = {}, rules } = getFormData(formGroup.groups);
  const formRef: any = useRef(null);
  const { groups } = formFields;
  const selectedStudy: string | null = useAppSelector(state => state.site.selectedStudy);
  const { handleError } = useUtil();
  const [shipDrugSupply, { isSuccess, isLoading, isError, error }] = useShipDrugSuppplyMutation();
  const dispatch = useDispatch();
  const [key, setKey] = useState(0);
  const [disableShipBtn, setDisableShipBtn] = useState<boolean>(true);

  const handleCancel = () => {
    setOpenShipPopup(false);
  };

  const handleShipSubmit = (data: any) => {
    setOpenShipPopup(true);
    shipDrugSupply({
      study_id: selectedStudy,
      site_id: data.records.transfer_to,
      country: selectedRowData.depot_country,
      application: 'CTMS',
      application_section: process.env.REACT_APP_TUDA_SLUG,
      application_module_section: process.env.REACT_APP_CONDUCT_NAME,
      data: {
        drug_supply_id: selectedRowData?.id,
        quantity_shipped: data.records.transfer_quantity,
        site_id: data.records.transfer_to
      }
    });
  };
  const handleShip = () => {
    formRef.current.submit(onFormSubmit);
  };

  const onFormSubmit = (data: any) => {
    if (data.errors) {
      return;
    }
    if (data.success) {
      if (openShipPopup) {
        handleShipSubmit(data);
      }
    }
  };

  const handlechange = async (key: string, value: any) => {
    if (key === 'transfer_quantity' && value) {
      if (value > Number(selectedRowData?.quantity)) {
        groups?.map((obj: any) => {
          obj?.fields.map((field: any) => {
            if (field.name === 'transfer_quantity') {
              field.rules.custom.duplicateEntry = true;
            }
          });
        });
      } else {
        groups?.map((obj: any) => {
          obj?.fields.map((field: any) => {
            if (field.name === 'transfer_quantity') {
              field.rules.custom.duplicateEntry = false;
            }
          });
        });
      }
      setDisableShipBtn(false);
    }
  };
  useEffect(() => {
    if (openShipPopup) {
      groups?.map((obj: any) => {
        obj?.fields.map((field: any) => {
          if (field.name === 'transfer_to') {
            field.values = sites ?? [];
          }
          if (field.name === 'transfer_quantity') {
            field.rules.max = selectedRowData?.quantity;
            field.rules.maxVal.value = selectedRowData?.quantity;
            field.rules.maxVal.errorText = `Max ${selectedRowData?.quantity}`;
          }
        });
      });
      setKey((pre: number) => pre + 1);
    }
  }, [openShipPopup, sites?.length]);

  useEffect(() => {
    if (isError) {
      handleError(error);
    }
  }, [isError]);
  useEffect(() => {
    if (!isLoading && isSuccess) {
      dispatch(setMessage({ msgDetails: 'Drug supply successfully shipped', severity: 'success' }));
      getRowsData();
      setOpenShipPopup(false);
      setSelectedRowData({});
    }
  }, [isLoading, isSuccess]);

  return (
    <AppModal
      open={openShipPopup}
      title={` Ship ${selectedRowData?.investigational_drug} from ${selectedRowData?.depot_name}`}
      saveButton={'Ship'}
      closeButton={'Cancel'}
      handleClose={handleCancel}
      handleSubmit={handleShip}
      disabled={disableShipBtn}
      maxWidth="600px"
    >
      <Loader />
      <Grid container spacing={2} rowSpacing={1} mb="24px">
        {shipData.map((data: any, index: number) => (
          <Grid item md={6} key={index}>
            <Typography variant="body1" sx={{ fontSize: 'clamp(14px, 15px, 16px)', wordBreak: 'break-word' }}>
              <strong style={{ display: 'inline-block', minWidth: 'fit-content' }}>{data.textValue}:&nbsp;</strong>
              <span className="results">{selectedRowData?.[data.apiKey]}</span>
            </Typography>
          </Grid>
        ))}
      </Grid>
      <FormLayoutBuilder
        initialValues={defaultValues}
        ref={formRef}
        columnSpacing={2}
        onChange={(key: string, value: any) => handlechange(key, value)}
        rules={rules}
        groups={groups}
        key={`Ship-Dialog${key}`}
      />
      <br />
      <br />
    </AppModal>
  );
};

export default ShipDialog;
